export const slabLikeElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'slabs',
    label: 'Decken',
  },
  {
    value: 'vertical_slabs',
    label: 'Deckenpositionen',
  },
  {
    value: 'slab_beams',
    label: 'Deckenbalken',
  },
]

export const foundationLikeElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'foundation',
    label: 'Fundament',
  },
]

export const wallLikeElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'outer_walls',
    label: 'Aussenwände',
  },
  {
    value: 'inner_walls',
    label: 'Innenwände',
  },
]

export const roofSlabLikeElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'roof_slabs',
    label: 'Dächer',
  },
  {
    value: 'vertical_roof_slabs',
    label: 'Dachpositionen',
  },
  {
    value: 'roof_slab_beams',
    label: 'Dachbalken',
  },
]

export const lineLikeElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'purlins',
    label: 'Pfetten',
  },
  {
    value: 'columns',
    label: 'Stützen',
  },
  {
    value: 'beams',
    label: 'Unterzüge',
  },
]

export const wallPositionElementTypes: {
  value: ElementTypes
  label: string
}[] = [
  {
    value: 'lintels',
    label: 'Fensterstürze',
  },
  {
    value: 'rips',
    label: 'Rippen',
  },
]

export const elementTypeConfig: {
  value: ElementTypes
  label: string
}[] = [
  ...foundationLikeElementTypes,
  ...wallLikeElementTypes,
  ...slabLikeElementTypes,
  ...roofSlabLikeElementTypes,
  ...lineLikeElementTypes,
]

export const elementTypes: ElementTypes[] = elementTypeConfig.map(({ value }) => value)
export const modelName = 'rendered-model'
export const absoluteTransmitterSnapTolerance = 0.05 // 5cm

const allElementTypesMap: Record<ElementTypes, ElementTypes> = {
  beams: 'beams',
  columns: 'columns',
  inner_walls: 'inner_walls',
  lintels: 'lintels',
  outer_walls: 'outer_walls',
  purlins: 'purlins',
  roof_slabs: 'roof_slabs',
  rips: 'rips',
  slabs: 'slabs',
  vertical_roof_slabs: 'vertical_roof_slabs',
  vertical_slabs: 'vertical_slabs',
  slab_beams: 'slab_beams',
  roof_slab_beams: 'roof_slab_beams',
  standard_rips: 'standard_rips',
  foundation: 'foundation',
}
export const allElementTypes = Object.keys(allElementTypesMap) as ElementTypes[]

export const FOUNDATION_REPLACEMENT_GUID = 'foundation-replacement'

export const MODEL_QUANTIZATION_NUM_DECIMALS = 2

export const elementTypeToLinewidthFloorplan: Record<
  'outer_walls' | 'inner_walls' | 'beams' | 'purlins',
  number
> = {
  outer_walls: 2,
  inner_walls: 2,
  beams: 2,
  purlins: 2,
}

/** Line width for floorplan walls that have a cartesian beam on top of them. */
export const WALL_WITH_BEAM_LINEWIDTH = 6

/** Line width for floorplan beams that overlap a cartesian wall below them. */
export const BEAM_WITH_WALL_LINEWIDTH = 3
